import { render, staticRenderFns } from "./StartForm18.vue?vue&type=template&id=3d6dbcea&scoped=true"
import script from "./StartForm18.vue?vue&type=script&lang=ts"
export * from "./StartForm18.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6dbcea",
  null
  
)

export default component.exports